import Range from '@/ts/if/Range'

export default class AcceItem {
  public name = ''
  public type: 'acce' | 'chara' = 'acce'
  public dispName = ''
  public imgPath = ''
  public thumbPath = ''
  public imgSvgPath = ''
  public imgSize = { w: 0, h: 0 }
  public scaleLimit: Range = { min: 0.3, max: 1.0 }
  public defaultScale = 0.6

  constructor (initial?: Partial<AcceItem>) {
    Object.assign(this, initial)
  }

  public get defaultSize () {
    return this.sizeOnScale(this.defaultScale)
  }

  public sizeOnScale (scale: number) {
    return { w: this.imgSize.w * scale, h: this.imgSize.h * scale }
  }
}
